import { shopName, checkHost } from './helpers/core.helpers'

const development = ['spoke-5.myshopify.com',  'spoke-2.myshopify.com', 'spoke-3.myshopify.com', 'spoke-staging.com', 'gb.spoke-staging.com'].includes(window.location.host)

const stagingUsa = ['spoke-sam.myshopify.com', 'us.spoke-staging.com', 'usa.spoke-staging.com'].includes(window.location.host) || (window.location.href.indexOf('spoke-staging.com/us') > -1)

const stagingDe = ['spoke-staging-de.myshopify.com', 'de.spoke-staging.com'].includes(window.location.host) || (window.location.href.indexOf('spoke-staging.com/de') > -1)

const stagingEu = ['spoke-staging-eu.myshopify.com', 'eu.spoke-staging.com'].includes(window.location.host) || (window.location.href.indexOf('spoke-staging.com/eu') > -1)

const productionUsa = ['us.spoke-london.com', 'usa.spoke-london.com'].includes(window.location.host) || (window.location.href.indexOf('spoke-london.com/us') > -1)

const productionDe = (window.location.host === 'de.spoke-london.com') || (window.location.href.indexOf('spoke-london.com/de') > -1)

const productionEu = (window.location.host === 'eu.spoke-london.com') || (window.location.href.indexOf('spoke-london.com/eu') > -1)

const production = (['spoke-london.com', 'gb.spoke-london.com'].includes(window.location.host) || (window.location.href.indexOf('spoke-london.com/gb') > -1)) && (window.location.href.indexOf('spoke-london.com/de') == -1) && (window.location.href.indexOf('spoke-london.com/us') == -1)

const environment = {
  gb: {
    development: {
      shop: 'spoke-2',
      hosts: [
        'spoke-2.myshopify.com',
        'spoke-3.myshopify.com',
        'spoke-5.myshopify.com'
      ]
    },
    staging: {
      shop: 'spoke-1',
      hosts: [
        'spoke-1.myshopify.com',
        'spoke-staging.com',
        'gb.spoke-staging.com',
        'spoke-staging.com/gb'
      ]
    },
    production: {
      shop: 'spokestyle',
      hosts: [
        'spoke-london.com',
        'gb.spoke-london.com',
        'spoke-london.com/gb'
      ]
    }
  },
  us: {
    staging: {
      shop: 'spoke-sam',
      hosts: [
        'spoke-sam.myshopify.com',
        'us.spoke-staging.com',
        'usa.spoke-staging.com',
        'spoke-staging.com/us'
      ]
    },
    production: {
      shop: 'spokestyle-us',
      hosts: [
        'us.spoke-london.com',
        'usa.spoke-london.com',
        'spoke-london.com/us'
      ]
    }
  },
  de: {
    staging: {
      shop: 'spoke-staging-de',
      hosts: [
        'spoke-staging-de.myshopify.com',
        'de.spoke-staging.com',
        'spoke-staging.com/de'
      ]
    },
    production: {
      shop: 'spokestyle-de',
      hosts: [
        'de.spoke-london.com',
        'spoke-london.com/de'
      ]
    }
  },
  eu: {
    staging: {
      shop: 'spoke-staging-eu',
      hosts: [
        'spoke-staging-eu.myshopify.com',
        'eu.spoke-staging.com',
        'spoke-staging.com/eu'
      ]
    },
    production: {
      shop: 'spokestyle-eu',
      hosts: [
        'eu.spoke-london.com',
        'spoke-london.com/eu'
      ]
    }
  }
}

const hostInHref = (hosts) => {
  for (const host of hosts) {
    if (window.location.href.indexOf(host) > -1) {
      return true
    }
  }

  return false
}

const getEnvObj = () => {
  for (const [country, countryObj] of Object.entries(environment)) {
    for (const [env, obj] of Object.entries(countryObj)) {
      const { shop, hosts } = obj

      if (hosts.includes(window.location.host) || hostInHref(hosts)) {
        return {
          environment: env,
          shop
        }
      }
    }
  }

  return {}
}

export function apiKey () {
  const { spokeApiKey } = document.body.dataset
  return spokeApiKey
}

export function fitApiKey () {
  const { spokeFitApiKey } = document.body.dataset
  return spokeFitApiKey
}

export function getFitApiConfig() {
  const { environment } = getEnvObj()
  const host = checkHost()?.toLocaleLowerCase()
 
  return {
    url: environment === 'production' ? `https://${host}.fit.spoke-london.com` : `https://${host}.fit.spoke-staging.com`,
    key: fitApiKey(),
    shop: shopName()
  }
}

export function getApiConfig() {
  const { environment } = getEnvObj()
  return {
    url: environment === 'production' ? 'https://apiv2.spoke-london.com' : 'https://apiv2.spoke-staging.com',
    key: apiKey(),
    shop: shopName()
  }
}

export {
  development,
  production,
  productionUsa,
  productionDe,
  productionEu,
  stagingUsa,
  stagingDe,
  stagingEu,
  getEnvObj
}
